import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef, KalSnackbarConfig, KalSnackbarService } from '@kalidea/kaligraphi';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { SharedFolderDeleteFolderAction, SharedFolderGetRelatedElementsAction } from 'src/app/_shared/stores/folder/folder.actions';
import { tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { SharedFolderState } from 'src/app/_shared/stores/folder/folder.state';

export interface DeleteFolderDialogData {
    folderId: number;
    countAlbumArticles: number;
    accepted?: boolean;
}

@Component({
    selector: 'app-delete-folder-dialog',
    templateUrl: './delete-folder-dialog.component.html',
    styleUrls: ['./delete-folder-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeleteFolderDialogComponent extends BaseComponent implements OnInit, OnDestroy {

    @Select(SharedFolderState.loading) loading$: Observable<boolean>;

    @Select(SharedFolderState.hasRelatedElements) hasRelatedElements$: Observable<boolean>;

    documentControl = new UntypedFormControl('keepDocument');

    constructor(private dialogRef: KalDialogRef<DeleteFolderDialogComponent>,
                private fb: UntypedFormBuilder,
                private snackbarService: KalSnackbarService,
                protected cdr: ChangeDetectorRef,
                @Inject(KAL_DIALOG_DATA) public data: DeleteFolderDialogData) {
        super(cdr);
    }

    get text(): string {
        if (this.data.countAlbumArticles === 1 && !this.snapshot(SharedFolderState.hasRelatedElements)) {
            return 'Souhaitez-vous supprimer ce dossier ?';
        } else if (this.data.countAlbumArticles > 0) {
            return 'Le dossier est utilisé ailleurs. Souhaitez-vous le supprimer ?';
        } else {
            return 'Ce dossier contient des documents. Quelle action souhaitez-vous effectuer pour ceux-ci ?';
        }
    }

    close(isAccepted?: boolean): void {
        this.dialogRef.close({accepted: isAccepted || false});
    }

    deleteFolder(): void {
        this.watch$ = this.dispatch$(new SharedFolderDeleteFolderAction({
            folderId: this.data.folderId, shouldDeleteRelatedFiles: this.documentControl.value === 'deleteDocuments'
        }))
            .pipe(
                tap(() => this.close(true)),
                tap(() => {
                    const snackarConfig = new KalSnackbarConfig({
                        title: 'Le dossier a bien été supprimé.'
                    });
                    this.snackbarService.open(snackarConfig);
                })
            );
    }

    ngOnInit(): void {
        this.dispatch$(new SharedFolderGetRelatedElementsAction(this.data.folderId));
    }

}
